import { render, staticRenderFns } from "./risk-dialog.vue?vue&type=template&id=2379d67e&scoped=true&"
import script from "./risk-dialog.vue?vue&type=script&lang=js&"
export * from "./risk-dialog.vue?vue&type=script&lang=js&"
import style0 from "./risk-dialog.vue?vue&type=style&index=0&id=2379d67e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2379d67e",
  null
  
)

export default component.exports